/*eslint-disable*/
import { urlReg, email, ebcuZipCOde } from '@/modules/mdm/utils/regList.js'
export const addedDictKeys = 'EBCU_CUSTOMER_TYPE_OVERSEAS,EBCU_CUSTOMER_TYPE'
const accountEntityEnabled = 1 // 会计主体启用状态
// 表单配置信息
export const collapse = [
    {
        title: '管理信息',
        ref: 'manageForm',
        formName: 'manageInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户编码',
                prop: 'customerCode',
                value: 'customerCode',
                type: 'custom',
            },
            {
                label: '客户名称',
                prop: 'customerName',
                value: 'customerName',
                type: 'custom',
                rule: [
                    { required: true, message: '客户名称不能为空', trigger: 'change' }
                ]
            },
            {
                label: '客户简称',
                prop: 'customerShortName',
                value: 'customerShortName',
                type: 'custom',
                rule: [
                    // 非虚拟客户必填
                    { required: true, message: '客户简称不能为空', trigger: 'change' }
                ]
            },
            {
                label: '英文名称',
                prop: 'ebcuNameEn',
                value: 'ebcuNameEn',
                type: 'input',
                rule: [
                    { required: false, message: '英文不能为空', trigger: 'change' }
                ]
            },
            {
                label: '主客户编码',
                prop: 'belongCustomerCode',
                value: 'belongCustomerCode',
                type: 'custom'
            },
            {
                label: '客户系',
                prop: 'customerGroupName',
                value: 'customerGroupName',
            },
            {
                label: '客户等级',
                prop: 'customerLevelCode',
                value: 'customerLevelCode',
                type: 'custom',
                optionsKey: 'NEOCRM_CUSTOMER_LEVEL', // 后端确认与细分等级用同一个 wy-yy
            },
            {
                label: '细分等级',
                prop: 'calCustomerLevelCode',
                value: 'calCustomerLevelCode',
                type: 'custom',
                optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            },
            {
                label: '客户大类编码',
                prop: 'customerCategoryCode',
                value: 'customerCategoryCode',
                type: 'custom',
            },
            {
                label: '客户大类',
                prop: 'customerCategory',
                value: 'customerCategory',
                type: 'custom',
            },
            {
                label: '行业大类',
                prop: 'industryCategoriesName',
                value: 'industryCategoriesName',
                type: 'custom'
            },
            {
                label: '细分行业',
                prop: 'industryType',
                value: 'industryType',
                type: 'custom',
                props: {
                    multiple: false,
                    value: 'industryCode',
                    label: 'industryName'
                },
                options: [],
                rule: [
                    { required: true, message: '细分行业不能为空', trigger: 'change' }
                ]

            },
            // {
            //     label: '细分行业',
            //     prop: 'industryType',
            //     value: 'industryType',
            //     type: 'select',
            //     optionsKey: 'SYS_INDUSTRY_TYPE',
            //     rule: [
            //         { required: true, message: '细分行业不能为空', trigger: 'change' }
            //     ]

            // },
            {
                label: '风险等级',
                prop: 'riskLevel',
                value: 'riskLevel',
                multiple: true,
                type: 'custom',
                optionsKey: 'LMDM_RISKLEVEL',

            },
            {
                label: '客户分类',
                prop: 'ebcuCustomerType',
                value: 'ebcuCustomerType',
                type: 'select',
                optionsKey: 'EBCU_CUSTOMER_TYPE',
                rule: [
                    { required: true, message: '客户分类不能为空', trigger: 'change' }
                ]
            },
            {
                label: '双算标识',
                prop: 'bizRevId',
                value: 'bizRevId',
                type: 'custom',
                optionsKey: 'BIZ_REV_ID_TYPE',
            },
            {
                label: '战略合作类型',
                prop: 'teamType',
                value: 'teamType',
                type: 'custom',
                // type: 'select',
                optionsKey: 'CUSTOMER_TEAM_TYPE',
            },
            {
                label: '内外渠',
                prop: 'customerChannel',
                value: 'customerChannel',
                optionsKey: 'LMDM_CUSTOMER_CHANNEL',
                type: 'custom',
                rule: [
                    { required: true, message: '内外渠不能为空', trigger: 'change' }
                ]
            },
            {
                label: '集团编码',
                prop: 'originalGroupCode',
                value: 'originalGroupCode',
                type: 'custom'
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                value: 'supplierCode',
                name: '请选择供应商编码',
                // type: 'advance',
                type: 'advance',
                advanceConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierName', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' }
                ],
                method: 'post',
                prefix: '/api-lcrm',
                advanceUrl: '/customer/info/querySupplier',
                cbParams: ['supplierCode', 'supplierNameCn#supplierName'],
                advanceCode: 'advanceCode',
                width: 150,
                visible: true,
                rule: [
                    { required: false, message: '供应商编码不能为空', trigger: 'change' }
                ],
                beforeRequest: (params) => {
                    params.data = {}
                    if (params.supplierCode) {
                        params.data.supplierCodeList = [params.supplierCode]
                    }
                    if (params.supplierName) {
                        params.data.supplierName = params.supplierName
                    }
                    delete params.supplierName
                    delete params.supplierCode
                    return params;
                }
            },
            {
                label: '所属事业部',
                prop: 'ebcuBuCode',
                value: 'ebcuBuCode',
                type: 'select',
                optionsKey: 'SYS_BUSINESS_UNIT',
                rule: [
                    { required: true, message: '所属事业部不能为空', trigger: 'change' }
                ]
            },
            {
                label: '美的渠道角色',
                prop: 'customerChannelRole',
                value: 'customerChannelRole',
                type: 'custom',
                optionsKey: 'LMDM_CUSTOMER_CHANNEL_ROLE',
                rule: [
                    { required: false, message: '美的渠道角色不能为空', trigger: 'change' }
                ]
            },
            {
                label: '内外销客户',
                prop: 'isImpExpCustomer',
                value: 'isImpExpCustomer',
                optionsKey: 'SYS_WM_IN_OR_OUT_SALE_CUSTOMER',
                type: 'custom',
                rule: [
                    { required: true, message: '内外销客户不能为空', trigger: 'change' }
                ]
            },
            {
                label: '客户经理/开发人',
                prop: 'customerOwnerName',
                value: 'customerOwnerName',
                rule: [
                    { required: true, message: '客户经理/开发人不能为空', trigger: 'change' }
                ],
                type: 'advance',

                advanceConfig: [
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                ],
                tableConfig: [
                    { 'prop': 'esusId', 'value': 'ID' },
                    { 'prop': 'esusLoginName', 'value': '美信号' },
                    { 'prop': 'esusUserNameCn', 'value': '姓名' },
                    { 'prop': 'esusPositionName', 'value': '职位' },
                    { 'prop': 'escoCompanyNameCn', 'value': '部门' }
                ],
                prefix: '/api-mdm',
                advanceUrl: `/selectUserCompany`,
                cbParams: ['esusUserNameCn#customerOwnerName', 'esusLoginName#customerOwnerCode']
            }
        ]
    },
    {
        title: '注册信息',
        ref: 'registerForm',
        formName: 'registerInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户控制类型',
                prop: 'customerBodyType',
                value: 'customerBodyType',
                type: 'custom',
                optionsKey: 'SYS_RELATION_LEVEL',
                rule: [
                    { required: false, message: '客户控制类型不能为空', trigger: 'change' }
                ]
            },
            {
                label: '社会信用代码',
                prop: 'societyCreditCode',
                value: 'societyCreditCode',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '社会信用代码不能为空', trigger: 'change' }
                ]
            },
            {
                label: '营业执照号/注册号',
                prop: 'ebcuBusinessNo',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '营业执照号/注册号不能为空', trigger: 'change' }
                ]
            },
            {
                label: '组织机构代码',
                prop: 'ebcuOrgBarcode',
                value: 'ebcuOrgBarcode',
                type: 'custom',
                visible: false,
                width: 140,
                rule: [
                    { required: false, message: '组织机构代码不能为空', trigger: ['change', 'blur'] }
                ]
            },
            {
                label: '纳税号',
                prop: 'ebcuTaxRegistNo',
                value: 'ebcuTaxRegistNo',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '纳税号不能为空', trigger: ['change'] }
                ]
            },
            {
                label: '法人代表',
                prop: 'ebcuLegalEntity',
                value: 'ebcuLegalEntity',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '法人代表不能为空', trigger: ['change'] }
                ]
            },
            {
                label: '中信保编码',
                prop: 'sinosureCode',
                value: 'sinosureCode',
                type: 'custom',
                visible: false,
                rule: [
                    { required: false, message: '中信保编码不能为空', trigger: ['change'] }
                ]
            },
            {
                label: '身份证',
                prop: 'idNumber',
                value: 'idNumber',
                type: 'custom',
                rule: [
                    { required: false, message: '身份证不能为空', trigger: ['change'] }
                ]
            },
            {
                label: '纳税登记人',
                prop: 'ebcuTaxpayers',
                value: 'ebcuTaxpayers',
                type: 'custom',
                width: 140,
                rule: [
                    { required: false, message: '纳税登记人不能为空', trigger: ['change', 'blur'] }
                ]
            },
            {
                label: '纳税人类型',
                prop: 'ebcuTaxpayersType',
                value: 'ebcuTaxpayersType',
                type: 'custom',
                optionsKey: 'SYS_TAXER_TYPE',
                rule: [
                    { required: false, message: '纳税人类型不能为空', trigger: ['change'] }
                ],
            },
            {
                label: '注册金额',
                prop: 'ebcuRegisteredCapital',
                value: 'ebcuRegisteredCapital',
                type: 'custom',
                width: 140,
                rule: [
                    { required: false, message: '注册金额不能为空', trigger: ['change', 'blur'] },
                ],
            },

            {
                label: '企业性质',
                prop: 'ebcuPlatformNature',
                value: 'ebcuPlatformNature',
                type: 'custom',
                optionsKey: 'SYS_SUPPLIER_NATURE',
                rule: [
                    { required: true, message: '企业性质不能为空', trigger: ['change', 'blur'] },
                ],
            },

            {
                label: '国家(地区)省市区',
                prop: 'addressCodes',
                value: 'addressCodes',
                type: 'custom',
                span: 12,
                rule: [
                    { required: true, message: '国家(地区)/省/市/区县不能为空', trigger: 'change' }
                ],
            },

            // {
            //     label: '国家',
            //     prop: 'ebcuEbplCountryCode',
            //     value: 'ebcuEbplCountryCode',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '国家不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '省',
            //     prop: 'ebcuEbplProviaddnceCode',
            //     value: 'ebcuEbplProvinceCode',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '省不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '市',
            //     prop: 'ebcuEbplCityCode',
            //     value: 'ebcuEbplCityCode',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '市不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '县区',
            //     prop: 'ebcuDistricts',
            //     value: 'ebcuDistricts',
            //     type: 'custom',
            //     rule: [
            //         { required: true, message: '县区不能为空', trigger: 'change' }
            //     ],
            // },
            // {
            //     label: '乡镇/街道',
            //     prop: 'ebcuTowns',
            //     value: 'ebcuTowns',
            //     type: 'custom',
            //     rule: [
            //         { required: false, message: '乡镇/街道不能为空', trigger: 'change' }
            //     ],
            // },
            {
                label: '地址',
                prop: 'ebcuAddress',
                value: 'ebcuAddress',
                type: 'custom',
                span: 12,
                rule: [
                    { required: false, message: '地址不能为空', trigger: 'change' }
                ],
            },
            {
                label: '注册地址',
                prop: 'tycAddress',
                value: 'tycAddress',
                type: 'custom',
                span: 12,
                rule: [
                    { required: false, message: '注册地址不能为空', trigger: 'change' }
                ],
            },
            {
                label: '成立日期',
                prop: 'ebcuRegistrationDate',
                value: 'ebcuRegistrationDate',
                type: 'custom',
                rule: [
                    { required: false, message: '成立日期不能为空', trigger: 'change' }
                ],
            },
            {
                label: '经营状态',
                prop: 'regStatus',
                value: 'regStatus',
                type: 'custom',
                rule: [
                    { required: false, message: '经营状态不能为空', trigger: 'change' }
                ],
            },
            {
                label: '经营范围',
                prop: 'businessScope',
                value: 'businessScope',
                type: 'custom',
                span: 24,
                rule: [
                    { required: false, message: '经营范围不能为空', trigger: ['change'] }
                ]
            },
            {
                label: '天眼参考行业',
                prop: 'tycIndustry',
                value: 'tycIndustry',
                type: 'custom',
                rule: [
                    { required: false, message: '天眼参考行业不能为空', trigger: 'change' }
                ],
            },
            {
                label: '人员规模',
                prop: 'staffNumRange',
                value: 'staffNumRange',
                type: 'custom',
                rule: [
                    { required: false, message: '人员规模不能为空', trigger: 'change' }
                ],
            },
            {
                label: '参保人数',
                prop: 'socialStaffNum',
                value: 'socialStaffNum',
                type: 'custom',
                rule: [
                    { required: false, message: '参保人数不能为空', trigger: 'change' }
                ],
            },
            {
                label: '实收注册资本',
                prop: 'actualCapital',
                value: 'actualCapital',
                type: 'custom',
                rule: [
                    { required: false, message: '实收注册资本不能为空', trigger: 'change' }
                ],
            },
            {
                label: '是否微小企业',
                prop: 'isMicroEnt',
                value: 'isMicroEnt',
                type: 'custom',
                optionsKey: 'SYS_YES_NO',
                rule: [
                    { required: false, message: '是否微小企业不能为空', trigger: 'change' }
                ],
            },

            {
                label: '智汇签验真',
                prop: 'isCertification',
                value: 'isCertification',
                type: 'custom',
                optionsKey: 'SYS_IS_CERTIFICATION',
                rule: [
                    { required: false, message: '智汇签验真不能为空', trigger: ['change'] }
                ],
            }
        ]
    },
    {
        title: '财务信息',
        ref: 'financeForm',
        formName: 'financeInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '是否关联交易',
                prop: 'isRelatedTransaction',
                value: 'isRelatedTransaction',
                type: 'custom',
                optionsKey: 'SYS_YES_NO',
                rule: [
                    { required: false, message: '是否关联交易不能为空', trigger: 'change' }
                ]
            },
            // {
            //     label: '内部OU组织',
            //     prop: 'ouOrganization',
            //     value: 'ouOrganization',
            //     type: 'custom',
            //     visible: true,
            //     rule: [
            //         { required: false, message: '内部OU组织不能为空', trigger: 'change' }
            //     ]
            // },
            {
                label: '内部OU组织',
                prop: 'ouOrganizationName',
                value: 'ouOrganizationName',
                name: '内部OU组织',
                type: 'advance',
                visible: true,
                rule: [
                    { required: false, message: '内部OU组织不能为空', trigger: ['change', 'blur'] }
                ],
                advanceConfig: [
                    { 'prop': 'operatingUnitName', 'value': '会计主体名称' },
                    { 'prop': 'operatingUnitId', 'value': '会计主体编码' }
                ],
                tableConfig: [
                    { 'prop': 'operatingUnitId', 'value': '会计主体编码' },
                    { 'prop': 'operatingUnitName', 'value': '会计主体名称' }
                ],
                prefix: '/api-lcrm',
                // method: 'post',
                advanceUrl: `/mdmService/efOrganRelations`,
                cbParams: ['operatingUnitId#ouOrganization', 'operatingUnitName#ouOrganizationName'], // legalSysId: 会计主体id
                beforeRequest: (params) => {
                    params.enabledFlag = accountEntityEnabled; // 启用状态
                    if (params.operatingUnitName) {
                        return params;
                    }
                    const inputKey = params.operatingUnitId?.trim();
                    const reg = new RegExp(/^-?\d+$/); // 数字正则
                    if (!reg.test(inputKey)) {
                        params.operatingUnitName = inputKey;
                        params.operatingUnitId = null;
                    } else {
                        params.operatingUnitId = inputKey;
                        params.operatingUnitName = null;
                    }

                    return params;
                },
                afterResponse: (res) => {
                    if (res && res.data && Array.isArray(res.data.list)) {
                        res.data.list = res.data.list.filter(item => !_.isNil(item))
                    }
                    return _.cloneDeep(res);
                },
            },
            {
                label: '是否POS机收款',
                prop: 'receiveByPos',
                value: 'receiveByPos',
                type: 'custom',
                visible: true,
                optionsKey: 'SYS_YES_NO',
                rule: [
                    { required: true, message: '是否POS机收款不能为空', trigger: 'change' }
                ]
            },
        ]
    },
    {
        title: '其他信息',
        ref: 'otherForm',
        formName: 'otherInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '销售产品',
                prop: 'mainProducts',
                value: 'mainProducts',
                type: 'input',
                rule: [
                    { required: true, message: '销售产品不能为空', trigger: 'change' }
                ]
            },
            {
                label: '公司简介',
                prop: 'companyProfile',
                value: 'companyProfile',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '公司简介不能为空', trigger: 'change' }
                ]
            },
            {
                label: 'AI简介（试行）',
                prop: 'introduction',
                value: 'introduction',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: 'AI简介（试行）不能为空', trigger: 'change' }
                ]
            },
            {
                label: '企业文化',
                prop: 'corporateCulture',
                value: 'corporateCulture',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '企业文化不能为空', trigger: 'blur' }
                ]
            },
            {
                label: '公司网址',
                prop: 'companyUrl',
                value: 'companyUrl',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '公司网址不能为空', trigger: 'blur' },
                    {
                        pattern: urlReg,
                        message: '公司网址格式不对',
                        trigger: 'blur'
                    }
                ]
            },
            {
                label: '电话',
                prop: 'ebcuTel',
                value: 'ebcuTel',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '电话不能为空', trigger: 'blur' },
                    {
                        pattern: '',
                        message: '电话格式不对,只允许输入数字、()、-',
                        trigger: 'blur'
                    }
                ]
            },
            {
                label: '传真',
                prop: 'ebcuFax',
                value: 'ebcuFax',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '传真不能为空', trigger: 'blur' }
                ]
            },
            {
                label: '电子邮箱',
                prop: 'ebcuEmail',
                value: 'ebcuEmail',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '电子邮箱不能为空', trigger: 'blur' },
                    {
                        pattern: email,
                        message: '电子邮箱格式不对',
                        trigger: 'blur'
                    }
                ]
            },
            {
                label: '邮编',
                prop: 'ebcuZipCode',
                value: 'ebcuZipCode',
                type: 'input',
                visible: true,
                rule: [
                    { required: false, message: '邮编不能为空', trigger: 'blur' },
                    {
                        pattern: ebcuZipCOde,
                        message: '邮编格式不对',
                        trigger: 'blur'
                    }
                ]
            },


        ]
    },
    {
        title: '系统信息',
        ref: 'systemForm',
        formName: 'systemInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '审批状态',
                prop: 'approvalStatus',
                value: 'approvalStatus',
                optionsKey: 'SYS_CUST_APPROVAL_STATUS',
                type: 'custom',
                rule: [
                    { required: false, message: '审批状态不能为空', trigger: 'change' }
                ]
            },
            {
                label: '来源系统',
                prop: 'sysSource',
                value: 'sysSource',
                type: 'custom',
                optionsKey: 'LCRM_CUSTOMER_SOURCE_SYS',
                visible: true,
                rule: [
                    { required: false, message: '来源系统不能为空', trigger: 'change' }
                ]
            },
            {
                label: '内外部客户',
                prop: 'isGroupCustomer',
                value: 'isGroupCustomer',
                optionsKey: 'INSIDE_OUTER_CLIENT',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '内外部客户不能为空', trigger: 'change' }
                ]
            },
            {
                label: '是否销售公司',
                prop: 'isSaleCompany',
                value: 'isSaleCompany',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '是否销售公司不能为空', trigger: 'change' }
                ]
            },
            {
                label: '是否代理商',
                prop: 'isAgent',
                value: 'isAgent',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '是否代理商不能为空', trigger: 'change' }
                ]
            },
            {
                label: '是否分销商',
                prop: 'isDistributor',
                value: 'isDistributor',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '是否分销商不能为空', trigger: 'change' }
                ]
            },
            {
                label: '客户销售易id',
                prop: 'crmCustomerId',
                value: 'crmCustomerId',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '客户销售易id不能为空', trigger: 'change' }
                ]
            },
            {
                label: '创建时间',
                prop: 'createTime',
                value: 'createTime',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '创建时间不能为空', trigger: 'change' }
                ]
            },
            {
                label: '创建用户',
                prop: 'createUserCode',
                value: 'createUserCode',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '创建用户不能为空', trigger: 'change' }
                ]
            },
            {
                label: '创建用户名称',
                prop: 'createUserName',
                value: 'createUserName',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '创建用户名称不能为空', trigger: 'change' }
                ]
            },
            {
                label: '更新时间',
                prop: 'updateTime',
                value: 'updateTime',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '更新时间不能为空', trigger: 'change' }
                ]
            },
            {
                label: '修改用户',
                prop: 'updateUserCode',
                value: 'updateUserCode',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '修改用户不能为空', trigger: 'change' }
                ]
            },
            {
                label: '修改用户名称',
                prop: 'updateUserName',
                value: 'updateUserName',
                type: 'custom',
                visible: true,
                rule: [
                    { required: false, message: '修改用户名称不能为空', trigger: 'change' }
                ]
            },

        ]
    },
];
